import type { ReactNode, ButtonHTMLAttributes } from 'react'

interface ConsoleIconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode
  /** 小屏隐藏（用于次要顶栏操作） */
  hideOnMobile?: boolean
}

/**
 * 控制台顶栏统一图标按钮：尺寸、边框、hover、focus 与 design token 一致。
 */
export default function ConsoleIconButton({
  children,
  hideOnMobile = false,
  className = '',
  type = 'button',
  ...rest
}: ConsoleIconButtonProps) {
  return (
    <button
      type={type}
      className={`console-icon-btn ${hideOnMobile ? 'hidden sm:inline-flex' : ''} ${className}`.trim()}
      {...rest}
    >
      {children}
    </button>
  )
}
